export default __webpack_public_path__ + "static/media/11.6874b794.jpg";